/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTokenLogOut
 */
export interface DeviceTokenLogOut {
    /**
     * 
     * @type {string}
     * @memberof DeviceTokenLogOut
     */
    deviceToken?: string;
}

/**
 * Check if a given object implements the DeviceTokenLogOut interface.
 */
export function instanceOfDeviceTokenLogOut(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeviceTokenLogOutFromJSON(json: any): DeviceTokenLogOut {
    return DeviceTokenLogOutFromJSONTyped(json, false);
}

export function DeviceTokenLogOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTokenLogOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'deviceToken': !exists(json, 'deviceToken') ? undefined : json['deviceToken'],
    };
}

export function DeviceTokenLogOutToJSON(value?: DeviceTokenLogOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'deviceToken': value.deviceToken,
    };
}

